// menuData.ts
export interface MenuItem {
  title: string;
  url?: string;
}

export interface MenuColumn {
  header: MenuItem;
  items: MenuItem[];
}

export interface MenuProps {
  columns: MenuColumn[];
}

export const menuData: MenuProps = {
  columns: [
    {
      header: { title: "Custom Software", url: "/custom-software" },
      items: [
        {
          title: "Architecture & Infrastructure",
          url: "/custom-software/architecture-and-infrastructure",
        },
        {
          title: "Web Development",
          url: "/custom-software/web-development",
        },
        {
          title: "ERP Solutions",
          url: "/custom-software/erp-solutions",
        },
        {
          title: "Custom Applications",
          url: "/custom-software/custom-applications",
        },
        { title: "App Mobile", url: "/custom-software/app-mobile" },
        { title: "eCommerce", url: "/custom-software/e-commerce" },
        {
          title: "Artificial Intelligence",
          url: "/custom-software/artificial-intelligence",
        },
      ],
    },
    {
      header: { title: "Strategic Design", url: "/strategic-design" },
      items: [
        {
          title: "UX Research & Strategy",
          url: "/strategic-design/ux-research-and-strategy",
        },
        { title: "UX Audit", url: "/strategic-design/ux-audit" },
        {
          title: "User Interface Design",
          url: "/strategic-design/ui-design",
        },
        {
          title: "Co-design Workshop",
          url: "/strategic-design/co-design-workshop",
        },
      ],
    },
    {
      header: {
        title: "System Integration",
        url: "/system-integration",
      },
      items: [
        {
          title: "App Integration",
          url: "/system-integration/app-integration",
        },
        {
          title: "Data Integration",
          url: "/system-integration/data-integration",
        },
        {
          title: "Cloud Enabling",
          url: "/system-integration/cloud-enabling",
        },
      ],
    },
    {
      header: { title: "Consulting", url: "/consulting" },
      items: [
        {
          title: "IT Strategy",
          url: "/consulting/it-strategy",
        },
        {
          title: "Digital Transformation",
          url: "/consulting/digital-transformation",
        },
        {
          title: "Technology Consulting",
          url: "/consulting/technology-consulting",
        },
        {
          title: "Change Management",
          url: "/consulting/change-management",
        },
      ],
    },
    {
      header: { title: "Industries" },
      items: [
        { title: "Automotive", url: "/industries/automotive" },
        { title: "Banking", url: "/industries/banking" },
        { title: "Energy", url: "/industries/energy" },
        {
          title: "Food & Beverage",
          url: "/industries/food-and-beverage",
        },
        {
          title: "Lifesciences & Healthcare",
          url: "/industries/life-sciences-and-healthcare",
        },
        { title: "Manufacturing", url: "/industries/manufacturing" },
        {
          title: "Media & Communication",
          url: "/industries/media-and-communication",
        },
        { title: "Public Sector", url: "/industries/public-sector" },
      ],
    },
  ],
};
